import request from '@/network/http'

export function deleteCheckupProjectInfo(data) {
    return request({
        url: 'Checkup/CheckupProject/deleteCheckupProjectInfo',
        method: 'post',
        data
    })
}

export function getCheckupProjectDetail(data) {
    return request({
        url: 'Checkup/CheckupProject/getCheckupProjectDetail',
        method: 'post',
        data
    })
}

export function saveCheckupProjectInfo(data) {
    return request({
        url: 'Checkup/CheckupProject/saveCheckupProjectInfo',
        method: 'post',
        data
    })
}

export function getCheckupProjectList(data) {
    return request({
        url: 'Checkup/CheckupProject/getCheckupProjectList',
        method: 'post',
        data
    })
}

export function getOrganizationTypeList() {
    return request({
        url: 'Base/Organization/getOrganizationTypeList',
        method: 'post',
    })
}

export function getCheckupSubjectList(data) {
    return request({
        url: 'Checkup/CheckupSubject/getCheckupSubjectList',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/apis/projectTemp.js